
import { useState } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography, Box, Accordion, AccordionSummary } from "@mui/material";
 
 

const PhysicalDamage = () => {
  // Set the default expanded state to the first accordion (panel0)
  const [expanded, setExpanded] = useState("panel0");

  // Data for each accordion
  const accordionData = [
    {
      title: "Accidents & Collisions",
      content: "Coverage for damages from crashes with vehicles, overturns, rollovers, and impacts with stationary objects.",
      image: "/img/rentshield/PhysicalDamagey_1.webp",
    },
    {
      title: "Damage & Vandalism",
      content: "Security against theft, intentional damage, and issues like glass breakage.",
      image: "/img/rentshield/PhysicalDamagey_2.webp",
    },
    {
      title: "Road & Environmental Hazards",
      content: "Safeguards your vehicle from potholes, road barriers, animal collisions, and other unexpected road risks.",
      image: "/img/rentshield/PhysicalDamagey_3.webp",
    },
    {
      title: "Weather & Natural Events",
      content: "Protection against natural disasters like floods, hail, earthquakes, and severe weather, as well as falling debris and fires.",
      image: "/img/rentshield/phyiscal-damage-4.png",
    },
  ];


  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (

 

            <div className="row">
                <div className="col-lg-6 col-sm-6">
                  <div className="onRentNewLeft">
                          {accordionData.map((accordion, index) => (
                            expanded === `panel${index}` ? (
                              <Box key={index} sx={{ textAlign: 'center' }}>
                                <img
                                  src={accordion.image}
                                  alt={`logo for ${accordion.title}`}
                                />
                              </Box>
                            ) : null
                          ))}
                  </div>
                </div>

                <div className="col-lg-6 col-sm-6">
                  <div className="onRentNewRight">
                      <h3><span>Physical Damage</span> Protection up to $110k</h3>
                      {accordionData.map((accordion, index) => (
                        <Box key={index} className="boxAccordian">
                          <Accordion className="headingAccordian"
                            expanded={expanded === `panel${index}`}
                            onChange={handleAccordionChange(`panel${index}`)}
                          >
                            <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    >
                              
                              <Typography>
                                {accordion.title}
                              </Typography>
                            </AccordionSummary>
                          </Accordion>
                          {/* Content below the accordion button */}
                          {expanded === `panel${index}` && (
                            <Box className="summaryAccordian">
                              <Typography>{accordion.content}</Typography>
                            </Box>
                          )}
                        </Box>
                      ))}
                  </div>
                </div>

            </div>
 
    
  );
};

export default PhysicalDamage;
